module.exports = __webpack_public_path__ + "static/img/liuliang.7b7054e7.png";